<div class="signin-main-container">
    <div class="signin-body">
        <h2 class="signin-sub-title">OTP Verification</h2>
        <p>Verification code was just sent to your email - <span>{{email}}</span>.</p>
        <ng-otp-input (onInputChange)="onOtpChange($event)"
            [config]="{length: maxLength, allowNumbersOnly: true}"></ng-otp-input>
        <div class="hint">Didn't get the code? <a (click)="onResend()" [class.disable]="secondsLeft">Resend</a>
            <div class="countdown-section"><mat-icon>timer</mat-icon>{{secondsLeft | formatTime}}</div>
        </div>
        <div class="signin-footer">
            <button mat-flat-button color="primary" class="verify-btn" (click)="onVerification()" [class.disable-button]="!secondsLeft" [disabled]="!secondsLeft">Verify</button>
        </div>
    </div>
</div>